import { EditorView } from "@codemirror/view"
import { syntaxHighlighting } from "@codemirror/language"
import { tags as t } from "@lezer/highlight"
import { HighlightStyle } from "@codemirror/language"

/** Matching bracket highlight when bracket is selected/hovered (bracketMatching plugins)
 * or when cursor is at matching bracket (native codemirror feature)
 */
export const MATCHING_BRACKET_CLASS = "cm-matchingBracket"

const highlightStyle = HighlightStyle.define([
  { tag: t.number, color: "#8839ef" },
  { tag: t.operator, color: "#179299", fontWeight: "bold" },
  { tag: t.function(t.variableName), color: "#40a02b", fontWeight: "bold" },
  { tag: t.propertyName, color: "#40a02b", fontWeight: "bold" },
  { tag: t.keyword, color: "#8839ef", fontWeight: "bold" },
  { tag: t.variableName, color: "#4c4f69" },
  { tag: t.paren, color: "#7287fd", fontWeight: "bold" },
  { tag: t.brace, color: "#9c08c5", fontWeight: "bold" },
  { tag: t.bracket, color: "#8839ef", fontWeight: "bold" },
  { tag: t.punctuation, color: "#8c8fa1" },
])

const theme = EditorView.theme(
  {
    ".cm-content": {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontSize: "16px",
      backgroundColor: "transparent",
      color: "rgba(0, 0, 0, 0.87)",
      padding: "16.5px 14px",
      minHeight: "1.4375em",
      border: "1px solid rgba(0, 0, 0, 0.23)",
    },
    ".cm-lintRange-error": {
      backgroundImage: `url("data:image/svg+xml,%3csvg width='6' height='4' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m0 3 l2 -2 l1 0 l2 2 l1 0' stroke='%23ff2222' fill='none' stroke-width='2'/%3e%3c/svg%3e")`,
    },
    ".cm-lintRange-warning": {
      backgroundImage: `url("data:image/svg+xml,%3csvg width='6' height='4' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m0 3 l2 -2 l1 0 l2 2 l1 0' stroke='%23ff9900' fill='none' stroke-width='2'/%3e%3c/svg%3e")`,
    },
    [`.${MATCHING_BRACKET_CLASS}`]: {
      backgroundColor: "rgba(114, 135, 253, 0.15)",
      outline: "1px solid rgba(114, 135, 253, 0.5)",
      borderRadius: "2px",
    },
    "&": {
      height: "auto",
    },
  },
  { dark: false },
)

export const expressionTheme = [theme, syntaxHighlighting(highlightStyle)]
